import { render, staticRenderFns } from "./page18.vue?vue&type=template&id=79db1660&scoped=true&"
import script from "./page18.vue?vue&type=script&lang=js&"
export * from "./page18.vue?vue&type=script&lang=js&"
import style0 from "./page18.vue?vue&type=style&index=0&id=79db1660&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79db1660",
  null
  
)

export default component.exports